import axiosClient from "./axiosClient";

export const login = (credentials) =>
    axiosClient.post("/users/login", credentials).then((res) => res.data);

export const register = (form) => axiosClient.post("/users/register", form).then((res) => res.data);

// Validates the stored token against the API.
export const getCurrentUser = () => axiosClient.get("/users/me").then((res) => res.data);

// Admin only.
export const getUsers = () => axiosClient.get("/users").then((res) => res.data);
